
<template>
  <!--添加管理员账号-->
  <div>
    <x-addEdit
      ref="form"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { searchMobileOrAccount } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, searchMobileOrAccount],
  name: 'addGovAccount',
  data () {
    return {
      newAreas: undefined,
      regionVal: '',
      regionList: [],
      regionIndex: 0,
      formList: [
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          blur: e => this.searchMobileOrAccount(e, 'mobile'),
          props: ['mobile', {
            rules: [{ required: true, message: '请输入手机号' }]
          }]
        },
        {
          label: '账号名',
          inputType: 'input',
          options: [],
          placeholder: '请输入账号名',
          blur: e => this.searchMobileOrAccount(e, 'userName'),
          props: ['userName', {
            rules: [
              { required: true, message: '请输入账号名' },
              { min: 2, max: 30, message: '账号名为2-30位' }
            ]
          }]
        },
        {
          label: '真实姓名',
          inputType: 'input',
          options: [],
          placeholder: '请输入真实姓名',
          props: ['trueName', {
            rules: [
              { required: true, message: '请输入真实姓名' },
              { min: 1, max: 10, message: '真实姓名为1-10位' }
            ]
          }]
        },
        {
          label: '选择角色',
          inputType: 'select',
          options: [],
          placeholder: '请选择角色',
          mode: 'multiple',
          props: ['roleId', {
            rules: [{ required: true, message: '请选择角色' }]
          }]
        },
        {
          label: '管理区域',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择管理区域',
          handle: this.regionChange,
          changeOnSelect: true,
          click: this.clickArea,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(4, 'formList', '1,2,3,4', e);
          },
          props: ['manageArea', {
            rules: [{ required: true, message: '请选择管理区域' }]
          }]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['remarks', {
            rules: [{ min: 2, max: 20, message: '描述信息为2-20位' }]
          }]
        }
      ],
      formKey: {
        userName: '',
        mobile: '',
        trueName: '',
        roleId: '',
        manageArea: '',
        remarks: ''
      },
      addParam: {
        url: '/govern/user',
        reqHandle: this.addReqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/govern/user/',
        reqHandle: this.editReqHandle,
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/govern/user/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    const routeQuery = this.$route.query.id;
    if (routeQuery) {
      let arr = this.formList.filter(item => item.props[0] === 'userName' || item.props[0] === 'mobile');
      arr.forEach((el) => { el.disabled = true; });
    }

    let mobileRules = this.formList[0].props[1].rules;
    routeQuery ? (mobileRules.splice(1, 1)) : (mobileRules.push({ pattern: this.REG.mobile, message: this.MESSAGE.mobile }));
    console.log(' gov mobile Rules: ', mobileRules);

    if (this.$route.query.canDelete === '0') {
      this.formList[4].disabled = true;
    }
    this.getSelect();
  },
  methods: {
    regionChange (val, selected) {
      if (val && selected && selected.length > 0) {
        let temp = [];
        selected.forEach(item => {
          let i = item.level - 1;
          temp[i] = item.value;
        });
        for (let i = 0; i < 4; i++) {
          if (temp[i] == undefined) {
            temp[i] = 0;
          }
        }
        this.newAreas = temp.toString();
      }
    },
    /* 获取下拉 */
    getSelect () {
      this.newRegionSelect((data) => {
        let area = this.formList[4];
        if (this.regionVal) {
          data.forEach((el) => {
            if (el.value === this.regionVal[0]) {
              area.options = [el];
            }
          });
        } else {
          area.options = data;
        }
      }, 'formList', '1,2,3,4');

      this.$get({
        url: '/role/govern/treeSelect',
        params: {}
      }).then(({data}) => {
        this.formList[3].options = data;
      });
    },
    /* 点击管理区域事件 */
    clickArea (val) {
      if (!this.newAreas) {
        this.newRegionSelect((data) => {
          this.formList[4].options = data;
        }, 'formList', '1,2,3,4');
      }
    },
    detailResHandle (res) {
      let manageArea;
      if (res.manageArea) {
        manageArea = res.manageArea;
        this.newAreas = manageArea.toString();
        manageArea.forEach((i, index) => {
          if (i == 0) {
            manageArea.splice(index, 1);
          }
        });
        res && Array.isArray(manageArea) && this.newRegionSelectByIds(4, manageArea, 4);
      }

      // let area = res.manageArea;
      // area && Array.isArray(area) && this.newRegionSelectByIds(4, area);
      this.regionVal = manageArea;
      return res;
    },
    filterRegion (region) {
      region.forEach((el) => {
        if (el.value === this.regionVal[this.regionIndex]) {
          let list = {...el};
          list.children = [];
          this.regionList.push(list);
          if (el.children && el.children.length) {
            this.regionIndex++;
            this.filterRegion(el.children);
          }
        }
      });
    },
    addReqHandle (param) {
      // param.manageArea = param.manageArea.join(',');
      param.manageArea = this.newAreas;
      param.roleId = param.roleId.join(',');
      return param;
    },
    editReqHandle (param) {
      param.manageArea = this.newAreas;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
